import { render, staticRenderFns } from "./MediacontactPartnerView.vue?vue&type=template&id=2f0d581b"
import script from "./MediacontactPartnerView.vue?vue&type=script&lang=js"
export * from "./MediacontactPartnerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports